<script>
export default {
    name: "CustomPagination",
    props: ["props"],
};
</script>

<template>
    <div class="VuePagination font-lato-medium-16" :class="props.theme.wrapper">
        <nav :class="props.theme.nav">
            <ul v-show="props.showPagination" :class="props.theme.list">
                <li v-if="props.hasEdgeNav" :class="props.theme.firstPage" @click="props.setFirstPage">
                    <button type="button" v-bind="props.firstPageProps">{{ props.texts.first }}</button>
                </li>

                <li v-if="props.hasChunksNav" :class="props.theme.prevChunk" @click="props.setPrevChunk">
                    <button type="button" v-bind="props.prevChunkProps">{{ props.texts.prevChunk }}</button>
                </li>

                <li :class="props.theme.prev" @click="props.setPrevPage">
                    <button type="button" v-bind="props.prevProps">{{ props.texts.prevPage }}</button>
                </li>

                <li v-for="page in props.pages" :key="page" :class="props.pageClasses(page)" v-on="props.pageEvents(page)">
                    <button type="button" v-bind="props.aProps" :class="props.theme.link">{{ page }}</button>
                </li>

                <li :class="props.theme.next" @click="props.setNextPage">
                    <button type="button" v-bind="props.nextProps">{{ props.texts.nextPage }}</button>
                </li>

                <li v-if="props.hasChunksNav" :class="props.theme.nextChunk" @click="props.setNextChunk">
                    <button type="button" v-bind="props.nextChunkProps">{{ props.texts.nextChunk }}</button>
                </li>

                <li v-if="props.hasEdgeNav" :class="props.theme.lastPage" @click="props.setLastPage">
                    <button type="button" v-bind="props.lastPageProps">{{ props.texts.last }}</button>
                </li>
            </ul>
            <p v-show="props.hasRecords" :class="props.theme.count">{{ $trans("main.pagination-count", { args: { from: (props.page - 1) * props.perPage + 1, to: props.page * props.perPage, records: props.records } }) }}</p>
        </nav>
    </div>
</template>

<style lang="scss" scoped>
div {
    p {
        margin-top: 10px;
    }

    ul {
        li.active.page-item {
            button.page-link {
                background-color: $font-turquoise;
                color: white;
            }
        }

        li.page-item {
            button.page-link {
                border: none;
                border-radius: unset;
                background-color: $background-blue;
                color: white;
                border-top-left-radius: unset;
                border-top-right-radius: unset;
                border-bottom-left-radius: unset;
                border-bottom-right-radius: unset;
            }

            button.page-link:hover {
                background-color: $background-light-blue;
                color: white;
            }

            button.page-link:active {
                background-color: $background-light-blue;
            }
        }

        li.disabled {
            display: none;
        }
    }
}
</style>
